import {useCallback} from 'react';

import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import WorkspaceStore from 'sidebar/WorkspaceStore';
import useStoreSelector from 'ui-library/hooks/useStoreSelector';

import {getWorkspaceContextIdsFromStore} from './ChatDAO';

/**
 * React hook that returns workspace context IDs for the given agent type.
 * Reactively updates when the sidepanel expansion state or active workspace item changes.
 */
export function useWorkspaceContextIds(agentType: AgentType | null): Array<string> {
  const isSidepanelExpanded = useStoreSelector(
    SidepanelStore,
    useCallback((store: typeof SidepanelStore) => store.getIsExpanded(), [])
  );
  const activeWorkspaceId = useStoreSelector(
    WorkspaceStore,
    useCallback((store: typeof WorkspaceStore) => store.activeId, [])
  );

  if (agentType == null) {
    return [];
  }

  return getWorkspaceContextIdsFromStore(agentType, {isSidepanelExpanded, activeWorkspaceId});
}
